import React, { Component } from 'react';
import styles from './CrudWithSteps.scss';
import { Container } from '../Container';
import StepsSidebar from './components/StepsSidebar';
import StepContent from './components/StepContent';
import PropTypes from 'prop-types';
import StepSidebar from './components/StepSidebar';
import StepsMenu from './components/StepsMenu';

const rootClassName = styles.rootClassName;

class CrudWithSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
    };
  }

  openStepsMenu = (event) => {
    this.setState({
      menuAnchorEl: event.currentTarget,
    });
  };

  closeStepsMenu = () => {
    this.setState({
      menuAnchorEl: null,
    });
  };

  getContents = () => {
    let contents = [];
    const totalContents = this.props.contents.length;
    this.props.contents.map((content, index) => {
      const $component = content.component;
      const componentProps = {
        ...(content.props || {}),
        contentIndex: this.props.contentIndex,
        totalContents: totalContents,
        openStepsMenu: this.openStepsMenu,
        setContentIndex: this.props.setContentIndex,
      };
      /* eslint-disable-next-line */
      contents.push(<$component {...componentProps} key={index} />);
      return index;
    });
    return contents;
  };

  componentDidUpdate() {
    if (this.props.contentIndex > this.props.contents.length - 1) {
      this.props.setContentIndex(this.props.contents.length - 1);
    }
  }

  render() {
    return (
      <Container className={rootClassName} noPadding>
        <StepsSidebar
          className={rootClassName + '-steps-sidebar'}
          steps={this.props.steps}
        />
        <StepContent
          content={this.getContents()}
          contentIndex={this.props.contentIndex}
        />
        <StepsMenu
          steps={this.props.steps}
          anchorEl={this.state.menuAnchorEl || null}
          onClose={this.closeStepsMenu}
        />
      </Container>
    );
  }
}

CrudWithSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.exact(StepSidebar.propTypes).isRequired)
    .isRequired,
  contents: PropTypes.arrayOf(
    PropTypes.exact({
      component: PropTypes.elementType.isRequired,
      props: PropTypes.objectOf,
    })
  ).isRequired,
  contentIndex: PropTypes.number.isRequired,
  setContentIndex: PropTypes.func.isRequired,
};

export default CrudWithSteps;
